module.exports = __webpack_public_path__ + "static/assets/620f707d6d9dcd512ec6604b0eda2cb3.svg";